
  import { css } from 'lit';
  export const styles = css`:host{--component-size: var(--ig-size, var(--default-size));--dropdown-size: var(--component-size)}[part=base]{border:.0625rem solid var(--border-color)}`;
  